import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "appintegration-component" }
const _hoisted_2 = { class: "component-contents" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 3,
  class: "appintegration-component__edit"
}

import { StateViewModel } from '@/features/bots/models/designer';
import { appsApi } from '@/features/apps/shared/services/apps';
import { InstalledApp } from '@/features/apps/shared/models';
import CapableAppModal from '@/shared/components/capableAppPicker/CapableAppModal.vue';
import IslandBadge from './IslandBadge.vue';
import { botsApi } from '../../services/bots';
import CardRenderer from '@/shared/components/cardRenderer/CardRenderer.vue';
import { Card } from '@/shared/components/cardRenderer';
import { AppCard } from '@/features/apps/shared/models/appCard';
import { BotAppInitViewModel } from '@/features/bots/models/request/botAppInitViewModel';
import { DELETE_STATE } from '@/store/bot-designer/states/actionTypes';
import ContentHighlightsEditModal from '@/shared/components/contentHighlights/ContentHighlightsEditModal.vue';
import EditIcon from 'vue-material-design-icons/SquareEditOutline.vue';
import { ConfiguredAppIntegration } from '@/features/apps/shared/models/configuredAppIntegration';
import { computed, onBeforeMount, PropType, ref, watch } from 'vue';
import { useStore } from 'vuex';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppIntegrationComponent',
  props: {
  value: {
    type: Object as PropType<StateViewModel>,
    required: true,
  },
},
  emits: ["state-updated"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const state = ref<StateViewModel>({
  id: '',
  component: 'AppIntegration',
});

const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);

const removeState = (stateToRemove: StateViewModel) => store.dispatch(DELETE_STATE, stateToRemove);

const actionColour = ref('#062B80');
const card = ref<Card>();
const capableApps = ref<InstalledApp[]>([]);
const showModal = ref(false);
const isLoading = ref(false);
const showAppEditModal = ref(false);

watch(
  () => props.value,
  (value) => (state.value = value),
  { immediate: true },
);

onBeforeMount(async () => {
  isLoading.value = true;
  await initialiseApps();
});

function close() {
  showModal.value = false;

  if (!state.value.appAction) {
    removeState(state.value);
  }
}

async function renderAppPreview(installedAppId: string, config: any) {
  isLoading.value = true;

  state.value.appAction = {
    installedAppId,
    config,
  };

  try {
    const request = { config } as BotAppInitViewModel;
    const appInitData = await botsApi.botAppInit(currentWorkspace.value.id, installedAppId, request);
    if (isPanelComponentsValid(appInitData.card)) {
      state.value.appAction.preview = JSON.stringify(appInitData.card.components);
      card.value = { id: appInitData.id, content: appInitData.card };
    }
  } catch {
    // just carry on
  } finally {
    isLoading.value = false;
  }

  emit('state-updated', state.value);
}

function getSelectedAppDescription() {
  let app: InstalledApp | undefined;
  if (state.value.appAction && state.value.appAction) {
    const installedAppId = state.value.appAction.installedAppId;
    app = capableApps.value.find((a) => a.installedAppId === installedAppId);
  }

  if (!app) {
    return '';
  }

  return app.name;
}

const configRequest = (workspaceId: string, installedAppId: string, values: any, storedData: any, componentId: any) => {
  return botsApi.botAppConfig(workspaceId, installedAppId, values, storedData, componentId);
};

function handleAppSave(app: ConfiguredAppIntegration) {
  showAppEditModal.value = false;
  state.value.appAction = app;
  renderAppPreview(state.value.appAction.installedAppId, state.value.appAction.config);
  emit('state-updated', state.value);
}

function openAppEditModal() {
  showAppEditModal.value = true;
}

function shouldShowEditButton() {
  const contentHighlightsApp = capableApps.value.find((app) => app.appId === 'contenthighlights');

  if (!contentHighlightsApp) {
    return false;
  }

  return props.value.appAction?.installedAppId === contentHighlightsApp.installedAppId;
}

async function initialiseApps() {
  try {
    const apps = await appsApi.getCapableApps(currentWorkspace.value.id, ['botActions']);
    capableApps.value = apps.map((app) => app as InstalledApp);
    if (!state.value.appAction) {
      showModal.value = true;
    } else {
      if (state.value.appAction.preview) {
        card.value = {
          id: state.value.appAction.installedAppId,
          content: {
            components: JSON.parse(state.value.appAction.preview),
          },
        };
      }
    }
  } finally {
    isLoading.value = false;
  }
}

function isPanelComponentsValid(panel: AppCard) {
  return panel && panel.components && panel.components.length > 0;
}

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(IslandBadge, { type: "appintegration" }),
    _createElementVNode("div", _hoisted_2, [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: _normalizeClass([{ 'is-loading': isLoading.value }, "button is-text"])
          }, null, 2))
        : _createCommentVNode("", true),
      (!isLoading.value && !card.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(getSelectedAppDescription()), 1))
        : _createCommentVNode("", true),
      (!isLoading.value && card.value)
        ? (_openBlock(), _createBlock(CardRenderer, {
            key: 2,
            colour: actionColour.value,
            cards: [card.value],
            location: 'embedded',
            readonly: true
          }, null, 8, ["colour", "cards"]))
        : _createCommentVNode("", true),
      (shouldShowEditButton())
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_n_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (openAppEditModal())),
              variant: "ghost"
            }, {
              default: _withCtx(() => [
                _createVNode(EditIcon),
                _cache[3] || (_cache[3] = _createTextVNode("Edit", -1))
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    (showModal.value)
      ? (_openBlock(), _createBlock(CapableAppModal, {
          key: 0,
          modalHeading: 'Bot Apps',
          capableApps: capableApps.value,
          configRequest: configRequest,
          onClose: close,
          onCompleted: renderAppPreview
        }, null, 8, ["capableApps"]))
      : _createCommentVNode("", true),
    (showAppEditModal.value)
      ? (_openBlock(), _createBlock(ContentHighlightsEditModal, {
          key: 1,
          "app-config": __props.value.appAction!,
          onCancel: _cache[1] || (_cache[1] = ($event: any) => (showAppEditModal.value = false)),
          onSave: _cache[2] || (_cache[2] = (app) => handleAppSave(app))
        }, null, 8, ["app-config"]))
      : _createCommentVNode("", true)
  ]))
}
}

})